export default "__VITE_ASSET__CWtYKXJN__"